import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Divider, Icon, Input, message, Row, Select, Tag } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { SUPPLIER } from '../../services/endpoint';
import './style.scss';
import { useHistory } from 'react-router-dom';

const { Option } = Select;

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

export default () => {

	const [ds, setDs] = useState([]);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const apiList = [await CommonService.get(SUPPLIER, {
				page: page.currentPage - 1,
				size: page.perpage
			})];
			const resp = Promise.all(apiList);
			const [supplierRes] = await resp;
			setDs(supplierRes.data?.contents);
			setPage({ ...page, total: supplierRes.data?.totalElements });
			window.setLoading(false);
		};
		window.setLoading(true);
		init();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(SUPPLIER, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã nhà cung cấp',
			dataIndex: 'code',
			align: 'center',
			width: 120,
			render: (text, record) => {
				return <Button style={{ padding: '0', height: 'fit-content' }} type={'link'} onClick={() => gotoDetail(record.id)}>{text}</Button>;
			}
		},
		{
			title: 'Tên nhà cung cấp',
			dataIndex: 'name',
			className: 'header-center-align',
			width: 170
		},
		{
			title: 'Số điện thoại',
			dataIndex: 'phoneNumber',
			className: 'header-center-align',
			width: 110
		},
		{
			title: 'Email',
			dataIndex: 'email',
			className: 'header-center-align',
			width: 150
		},
		{
			title: 'Địa chỉ',
			dataIndex: 'address1',
			className: 'header-center-align',
			width: 150,
		},
		{
			title: 'Trạng thái',
			dataIndex: 'isTransaction',
			width: 100,
			align: 'center',
			render: (value) => value ? <Tag style={{ width: '100px' }} color="#87d068">Đang giao dịch</Tag> :
				<Tag style={{ width: '110px' }} color="#f50">Ngừng giao dịch</Tag>
		},
		// {
		// 	title: 'Ngày khởi tạo',
		// 	dataIndex: 'createdDate',
		// 	width: 200,
		// 	align: 'center',
		// 	render: (text) => (<span>{dateToString(text)}</span>)
		// },
		// {
		// 	title: 'Ngày cập nhât',
		// 	dataIndex: 'updatedDate',
		// 	width: 200,
		// 	align: 'center',
		// 	render: (text) => (<span>{dateToString(text)}</span>)
		// },
		// {
		// 	title: 'Thao tác',
		// 	width: 200,
		// 	align: 'center',
		// 	render: (el) => (<Button onClick={() => gotoEdit(el.id)}>Sửa</Button>)
		// }
	];

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const gotoCreate = () => {
		history.push('/supplier/create');
	};

	const gotoDetail = (id) => {
		history.push('/supplier/' + id);
	};

	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};

	return (<Fragment>
			<Row className="mb-10" id={'product__action'}>
				<Col style={{visibility: 'hidden'}}>
					<div>
						<Divider type="vertical" />
						<Icon type="download" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Xuất file')}>Xuất file</span>
						<Divider type="vertical" />
						<Icon type="upload" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Nhập file')}>Nhập file</span>
					</div>
				</Col>
				<Col>
					<Button type="primary" style={{ width: '170px' }} id={'btn-create-product'} icon="plus"
									onClick={gotoCreate}>Thêm nhà cung cấp</Button>
				</Col>
			</Row>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã nhà cung cấp, SĐT, tên nhà cung cấp"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'value')}
						onKeyDown={onEnter}
					/>
					<Select placeholder={'Trạng thái giao dịch'}
									style={{ width: 300 }}
									allowClear
									onChange={(value) => handleChange(value, 'isTransaction')}>
						<Option value={true}>Đang giao dịch</Option>
						<Option value={false}>Ngừng giao dịch</Option>
					</Select>
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
			/>
		</Fragment>

	);
};
